var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    width: 59.0001,
    height: 59,
    rx: 29.5,
    fill: "#80E0C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2579 19.8141C38.2249 18.8963 36.0742 18.2442 33.8625 17.875C33.587 18.3555 33.2652 19.0019 33.0432 19.5161C30.6586 19.1701 28.296 19.1701 25.9552 19.5161C25.7334 19.002 25.4043 18.3555 25.1262 17.875C22.9124 18.2444 20.7598 18.8982 18.7258 19.8189C14.6784 25.7201 13.5812 31.4745 14.1297 37.1475C16.8142 39.0817 19.4158 40.2567 21.9736 41.0256C22.6092 40.1822 23.1711 39.2892 23.6535 38.356C22.7351 38.0187 21.8498 37.603 21.0081 37.1138C21.2296 36.9554 21.4459 36.7903 21.6567 36.6188C26.7574 38.9207 32.2996 38.9207 37.3395 36.6188C37.5511 36.7892 37.7674 36.9543 37.9879 37.1138C37.1448 37.6043 36.2579 38.0208 35.3377 38.3585C35.8228 39.2955 36.3837 40.1893 37.0176 41.0279C39.5778 40.2591 42.1818 39.0841 44.8663 37.1475C45.51 30.5711 43.7668 24.8695 40.2579 19.8141ZM24.3484 33.6587C22.8172 33.6587 21.5615 32.2795 21.5615 30.6C21.5615 28.9205 22.7904 27.5389 24.3484 27.5389C25.9065 27.5389 27.1622 28.918 27.1354 30.6C27.1378 32.2795 25.9065 33.6587 24.3484 33.6587ZM34.6476 33.6587C33.1163 33.6587 31.8607 32.2795 31.8607 30.6C31.8607 28.9205 33.0896 27.5389 34.6476 27.5389C36.2057 27.5389 37.4613 28.918 37.4345 30.6C37.4345 32.2795 36.2057 33.6587 34.6476 33.6587Z",
    fill: "#111512"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.11a071e1c81d4d7ff23ea63693ea5031.svg";
export { ForwardRef as ReactComponent };